import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import PageTitle from 'components/_base/PageTitle';

import ContentQuery from './ContentQuery';

const App = () => {
  return (
    <>
      <HeaderApp />
      <div className="panel">
        <PageTitle title="Consulta" />
        <hr />
        <ContentQuery />
      </div>
      <Bottom />
    </>
  );
};

export default App;
